import { useEffect } from 'react';

import {
  deletePageContentItem,
  saveSnapshot
} from '@src/actions/wysiwyg/editor';
import { useDispatch } from 'react-redux';

interface Props {
  itemId: string;
}

export default function KeyBindingDelete({ itemId }: Props) {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Delete' || event.key === 'Backspace') {
        event.preventDefault();
        event.stopPropagation();

        dispatch(saveSnapshot());
        dispatch(deletePageContentItem(itemId));
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch, itemId]);

  return null;
}
